import { FC } from 'react';
import { StepNav } from './index';
import { useScopedState } from 'informed';
import { CommonProps } from '../layout/LoanForm';
import { FinanceInformationStep, noIncomeEmploymentOptions } from '../model/formState';

interface Props {
  onNext?: () => void;
  onBack?: () => void;
}

const MaybeFinishNav: FC<CommonProps & Props> = (props) => {
  const {
    t,
    // open,
    onNext,
    onBack,
    // setFinishModalOpen
  } = props;

  const { value: financeInformation } = useScopedState();

  const incomeSource = (financeInformation as FinanceInformationStep).income_source;

  const isEmployeeStepNeeded = !incomeSource || !noIncomeEmploymentOptions.includes(incomeSource);

  return (
    <StepNav
      t={t}
      onNext={isEmployeeStepNeeded ? onNext : undefined}
      onBack={onBack}
      customNextText={isEmployeeStepNeeded ? '' : t.employeeStep.sendMotion}
    />
  );
};

export default MaybeFinishNav;
